__turbopack_context__.v({
  "icon": "ImageWrapperMob-module-scss-module__UEi2QW__icon",
  "image": "ImageWrapperMob-module-scss-module__UEi2QW__image",
  "imgButton": "ImageWrapperMob-module-scss-module__UEi2QW__imgButton",
  "modal": "ImageWrapperMob-module-scss-module__UEi2QW__modal",
  "modalImage": "ImageWrapperMob-module-scss-module__UEi2QW__modalImage",
  "scrollDisabled": "ImageWrapperMob-module-scss-module__UEi2QW__scrollDisabled",
  "wrapper": "ImageWrapperMob-module-scss-module__UEi2QW__wrapper",
});
